/* ===================== 求肥屋 theme.js ===================== */
(function () {
  /* ---------- header solid on scroll ---------- */
  var hdr = document.getElementById('hdr');
  if (hdr) {
    addEventListener('scroll', function () {
      hdr.classList.toggle('solid', scrollY > 40);
    }, { passive: true });
  }

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.16 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---------- mobile menu ---------- */
  var mmenu = document.getElementById('mmenu');
  var burger = document.getElementById('burger');
  window.toggleMenu = function (open) {
    if (!mmenu) return;
    mmenu.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  if (burger) burger.onclick = function () { toggleMenu(true); };

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var fmt = function (cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  };

  window.openCart = function () {
    if (!drawer) { location.href = window.routes.cart_url; return; }
    drawer.classList.add('open'); scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  };
  window.closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.classList.remove('open');
    document.body.style.overflow = '';
  };
  var cartOpen = document.getElementById('cartOpen');
  if (cartOpen) cartOpen.onclick = openCart;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- add to cart (event delegation) ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-add-to-cart]');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    var label = btn.textContent;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.add('done'); btn.textContent = '追加しました';
        setTimeout(function () { btn.classList.remove('done'); btn.textContent = label; btn.disabled = false; }, 1300);
        openCart();
      })
      .catch(function () { btn.disabled = false; });
  });

  /* ---------- change qty / remove ---------- */
  window.changeQty = function (key, qty) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  };

  function fetchCart() {
    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    try { document.dispatchEvent(new CustomEvent('gyuhiya:cart', { detail: cart })); } catch (e) {}
    var body = document.getElementById('cartBody');
    setCount(cart.item_count);
    var sub = document.getElementById('subtotal');
    var checkout = document.getElementById('checkout');
    if (sub) sub.textContent = fmt(cart.total_price);
    var q = window.GYUHIYA_SHIP.quote(cart.total_price);
    var shipEl = document.getElementById('cartship');
    var totEl  = document.getElementById('carttotal');
    var freeEl = document.getElementById('cartfree');
    if (shipEl) shipEl.textContent = q.shipLabel;
    if (totEl)  totEl.textContent  = q.totalLabel;
    if (freeEl) {
      if (cart.item_count === 0) {
        freeEl.textContent = '7,000円以上で送料半額、10,000円以上で送料無料';
        freeEl.className = 'free-ship';
      } else {
        freeEl.textContent = q.note;
        freeEl.className = q.stage === 'free' ? 'free-ship on' : 'free-ship';
      }
    }
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty">カートは空です。<br>静かな贅沢を、ひと匙どうぞ。</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_120x$1') : '';
      return '<div class="ci">' +
        '<img src="' + img + '" alt="">' +
        '<div><div class="nm">' + it.product_title + ((it.variant_title && it.variant_title !== 'Default Title') ? '　' + it.variant_title : '') + '</div>' +
        '<div class="pr">' + fmt(it.final_price) + ' 税込</div>' +
        '<div class="qty"><button onclick="changeQty(\'' + it.key + '\',' + (it.quantity - 1) + ')">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button onclick="changeQty(\'' + it.key + '\',' + (it.quantity + 1) + ')">＋</button></div></div>' +
        '<button class="rm" onclick="changeQty(\'' + it.key + '\',0)">削除</button>' +
        '</div>';
    }).join('');
  }

  window.checkout = function () { location.href = '/checkout'; };

  /* ---------- 配達希望日・時間帯（注文情報として保存） ---------- */
  var LEAD_DAYS = 5;    // 最短で何日後から指定できるか
  var RANGE_DAYS = 30;  // 何日先まで選べるか
  var WD = ['日', '月', '火', '水', '木', '金', '土'];

  /* 選べる日だけを選択肢として作る（＝無効な日はそもそも存在しない） */
  function buildDateOptions(sel) {
    var frag = document.createDocumentFragment();
    for (var i = LEAD_DAYS; i <= RANGE_DAYS; i++) {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + i);
      var val = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      var o = document.createElement('option');
      o.value = val;
      o.textContent = (d.getMonth() + 1) + '月' + d.getDate() + '日(' + WD[d.getDay()] + ')';
      frag.appendChild(o);
    }
    sel.appendChild(frag);
  }

  function initDelivery() {
    var dEl = document.querySelector('[data-deliv-date]');
    var tEl = document.querySelector('[data-deliv-time]');
    if (!dEl || !tEl) return;
    buildDateOptions(dEl);

    function save() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: { '配達希望日': dEl.value || '', '配達時間帯': tEl.value || '' }
        })
      });
    }
    dEl.addEventListener('change', save);
    tEl.addEventListener('change', save);

    /* 既に選んでいた値を復元 */
    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.attributes) return;
        if (c.attributes['配達希望日']) dEl.value = c.attributes['配達希望日'];
        if (c.attributes['配達時間帯']) tEl.value = c.attributes['配達時間帯'];
      });
  }
  initDelivery();

  /* initial count */
  fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { setCount(c.item_count); });
})();
